export const obterLarguraColunaReferencia = () : number => {
    return document.getElementById('th-coluna-Referencia-grid-itens')?.clientWidth ?? 0
}